// What kind of login is stored, for choosing screens only: the backend decides
// what each token may do.

// A platform operator's token carries "scope": "platform" and no organisation.
export function isPlatformToken(token = localStorage.getItem("token")) {
	if (!token) return false;
	try {
		const payload = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
		return JSON.parse(atob(payload)).scope === "platform";
	} catch {
		return false;
	}
}

// Where live run updates come from when the organisation has a dedicated
// executor (null = the shared one). Kept with the login so socketService knows
// it before any page connects.
const EXECUTOR_SOCKET_KEY = "executorSocketUrl";

export function rememberExecutorSocketUrl(user) {
	if (user?.executorSocketUrl) localStorage.setItem(EXECUTOR_SOCKET_KEY, user.executorSocketUrl);
	else localStorage.removeItem(EXECUTOR_SOCKET_KEY);
}

export function executorSocketUrl() {
	return localStorage.getItem(EXECUTOR_SOCKET_KEY);
}

export function forgetExecutorSocketUrl() {
	localStorage.removeItem(EXECUTOR_SOCKET_KEY);
}
